import React from 'react'

type Props = {
  width?: number
  height?: number
}

export function CardsIconVisa({ width = 39, height = 24 }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 39 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M36.9235 0H2.78333C1.65766 0 0.745117 0.912541 0.745117 2.03822V21.9618C0.745117 23.0875 1.65766 24 2.78333 24H36.9235C38.0491 24 38.9617 23.0875 38.9617 21.9618V2.03822C38.9617 0.912541 38.0491 0 36.9235 0Z"
          fill="#0E4595"
        />
        <path
          d="M14.9209 17.0303L16.6208 7.05518H19.3398L17.6387 17.0303H14.9209Z"
          fill="white"
        />
        <path
          d="M27.4617 7.27052C26.923 7.06843 26.079 6.85156 25.0249 6.85156C22.3383 6.85156 20.4458 8.20448 20.4297 10.1435C20.4146 11.5768 21.7807 12.3764 22.8121 12.8535C23.8704 13.3425 24.2262 13.6543 24.2211 14.0909C24.2144 14.7595 23.376 15.065 22.5945 15.065C21.5062 15.065 20.9281 14.9138 20.0352 14.5414L19.6848 14.3828L19.3032 16.6159C19.9383 16.8943 21.1126 17.1356 22.3319 17.1481C25.1899 17.1481 27.0453 15.8106 27.0664 13.7401C27.0767 12.6053 26.3523 11.7418 24.7837 11.0299C23.8333 10.5684 23.2513 10.2605 23.2575 9.79322C23.2575 9.37859 23.7501 8.93523 24.8145 8.93523C25.7036 8.92142 26.3477 9.11531 26.8495 9.3174L27.0931 9.43251L27.4617 7.27052Z"
          fill="white"
        />
        <path
          d="M34.4582 7.05518H32.3572C31.7064 7.05518 31.2193 7.23281 30.9335 7.88239L26.8955 17.0239H29.7506C29.7506 17.0239 30.2174 15.7948 30.323 15.5249C30.635 15.5249 33.4086 15.5292 33.8051 15.5292C33.8864 15.8784 34.1359 17.0239 34.1359 17.0239H36.6588L34.4582 7.05518ZM31.1248 13.4963C31.3497 12.9216 32.2081 10.7079 32.2081 10.7079C32.192 10.7344 32.4313 10.1303 32.5686 9.75581L32.7524 10.6158C32.7524 10.6158 33.273 12.9969 33.3818 13.4962H31.1248V13.4963Z"
          fill="white"
        />
        <path
          d="M3.08307 7.05518L3.04834 7.26278C4.12304 7.52293 5.08295 7.89939 5.92334 8.36778L8.33586 17.0145L11.2126 17.0111L15.493 7.05518H12.6129L9.95101 13.8575L9.66737 12.4752C9.65425 12.433 9.64004 12.3906 9.62547 12.3483L8.69981 7.89733C8.53523 7.26569 8.05785 7.07719 7.46733 7.05518H3.08307Z"
          fill="white"
        />
      </g>
    </svg>
  )
}
